import React from 'react';

/**
 * Texto de un mensaje de WhatsApp tal como se guarda o se enviaría.
 * Lo comparten el detalle del listado y las vistas previas de reenvío.
 */
const MessagePreview = ({ message, title }) => (
  <div>
    {title && <h3 className="text-sm font-semibold text-gray-700 mb-1">{title}</h3>}
    <pre className="whitespace-pre-wrap break-words text-sm text-gray-900 bg-gray-50 border border-gray-200 rounded-lg p-4 font-sans">
      {message || 'No se pudo generar el texto de este mensaje.'}
    </pre>
  </div>
);

export default MessagePreview;
